import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CButton from '@/components/shared/CButton/CButton.vue';
import googleLogo from '@/assets/images/google-logo.png';
import etsyLogo from '@/assets/images/etsy-logo.svg';
import type { ExternalProvider } from '@/typings/auth/externalAuth';


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialAuthButton',
  props: {
    provider: null,
    label: null,
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (event: 'click'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    /** Omitted for the email option, which shares the provider card look without a logo. */
    provider?: ExternalProvider;
    label: string;
    loading?: boolean;
    disabled?: boolean;
};





const icons: Record<ExternalProvider, string> = { google: googleLogo, etsy: etsyLogo };
const icon = computed(() => props.provider && icons[props.provider]);

return { __sfc: true,props, emit, icons, icon, CButton }
}

})